import { render } from "./CreateFeedback.vue?vue&type=template&id=1eff0dd4"
import script from "./CreateFeedback.vue?vue&type=script&lang=js"
export * from "./CreateFeedback.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__